import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { User as UserIcon } from 'lucide-react';
import UniversityDashboard from './UniversityDashboard';
import AgentDashboard from './AgentDashboard';
import SuperAdminDashboard from './SuperAdminDashboard';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
  const { profile, isLoading } = useAuth();
  const navigate = useNavigate();

  console.log('Dashboard rendered - isLoading:', isLoading, 'profile:', profile);

  if (isLoading) {
    return (
      <div className="p-6 space-y-8 bg-gray-200 min-h-screen">
        <div className="max-w-7xl mx-auto">
          <Skeleton className="h-8 w-1/3 mb-4" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <Skeleton className="h-32 rounded-3xl" />
            <Skeleton className="h-32 rounded-3xl" />
            <Skeleton className="h-32 rounded-3xl" />
            <Skeleton className="h-32 rounded-3xl" />
          </div>
          <Skeleton className="h-96 rounded-3xl" />
        </div>
      </div>
    );
  }

  // Show login screen if not authenticated
  if (!profile) {
    return (
      <div className="p-6 bg-gray-200 min-h-screen flex items-center justify-center">
        <div className="text-center max-w-md">
          <div className="w-24 h-24 neumorphic rounded-3xl flex items-center justify-center mx-auto mb-6">
            <UserIcon className="w-12 h-12 text-indigo-600" />
          </div>
          <h2 className="text-2xl font-bold text-neumorphic mb-4">Welcome to UniMentor</h2>
          <p className="text-gray-600 mb-6">
            Please log in to access your dashboard and manage your recruitment activities.
          </p>
          <Button
            onClick={() => navigate('/login')}
            className="neumorphic rounded-2xl px-8 py-3 bg-gradient-to-r from-indigo-500 to-purple-600 text-white"
          >
            Login to Continue
          </Button>
        </div>
      </div>
    );
  }

  // Route based on user role
  const role = profile.role;

  if (role === 'super_admin') {
    return <SuperAdminDashboard />;
  }
  
  if (role === 'university_admin') {
    return <UniversityDashboard />;
  }
  
  return <AgentDashboard />;
}